export enum Role {
  INVITEE = 'INVITEE',
  BASIC_USER = 'BASIC_USER',
  ADMIN = 'ADMIN',
  MASTER = 'MASTER',
  CUSTOMER = 'CUSTOMER',
  TRUSTEE = 'TRUSTEE',
}
